export const initialState = {
    collapsByWeek: true,
    collapsGraph: false,
    collapsSpecialDays: false,
};
